import { useState } from "react";
import { roundAwayFromZero } from "shared/utils/numberUtils";

export const usePriceState = (vatRate: server.dto.VatRate, isIncludingVat: boolean, valueExVat: number) => {
  const [vat, setVat] = useState(vatRate);
  const [isIncVat, setIsIncVat] = useState(isIncludingVat);
  const [valueExVatState, setValueExVatState] = useState(valueExVat);
  const [valueIncVatState, setValueIncVatState] = useState(roundAwayFromZero(valueExVat * (1 + vatRate.percentage)));

  const onVatRateChange = (newVatRate: server.dto.VatRate) => {
    setVat(newVatRate);
    if (isIncVat) {
      setValueExVatState(roundAwayFromZero(valueIncVatState / (1 + newVatRate.percentage)));
    } else {
      setValueIncVatState(roundAwayFromZero(valueExVatState * (1 + newVatRate.percentage)));
    }
  }

  const onValueChange = (isIncVat: boolean, value: number) => {
    setIsIncVat(isIncVat);
    if (isIncVat) {
      setValueIncVatState(roundAwayFromZero(value));
      setValueExVatState(roundAwayFromZero(value / (1 + vat.percentage)));
    } else {
      setValueExVatState(roundAwayFromZero(value));
      setValueIncVatState(roundAwayFromZero(value * (1 + vat.percentage)));
    }
  }

  return [valueExVatState, valueIncVatState, isIncVat, vat, onVatRateChange, onValueChange] as const;
}